import { useSuspenseQuery } from '@tanstack/react-query';
import Axios from 'api/client';
import { IS_PREVIEW, IS_PRODUCTION } from 'constants/runtime';
import { useAppState } from 'customHooks/useAppState';
import { opsQueryKeys } from 'queries/ops-query-keys';

const useConfigureHttpClient = () => {
    const { apiUrl } = useAppState();
    const subdomain = getSubdomain(apiUrl);

    useSuspenseQuery({
        queryKey: opsQueryKeys.axiosApiUrl(apiUrl),
        queryFn: () => {
            Axios.defaults.baseURL = `${apiUrl}/api`;
            Axios.defaults.withXSRFToken = true;
            Axios.defaults.withCredentials = true;

            if (!IS_PRODUCTION && IS_PREVIEW && subdomain) {
                Axios.defaults.xsrfCookieName = `XSRF-TOKEN-${subdomain}`;
                Axios.defaults.xsrfHeaderName = `X-XSRF-TOKEN-${subdomain}`;
            }

            // Allow overrides from env. For more static environments like demo or prod
            if (import.meta.env.VITE_DASHBOARD_XSRF_COOKIE_NAME) {
                Axios.defaults.xsrfCookieName = import.meta.env.VITE_DASHBOARD_XSRF_COOKIE_NAME;
            }

            if (import.meta.env.VITE_DASHBOARD_XSRF_TOKEN_NAME) {
                Axios.defaults.xsrfHeaderName = import.meta.env.VITE_DASHBOARD_XSRF_TOKEN_NAME;
            }

            return Promise.resolve(true);
        },
        staleTime: 0,
        retry: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    });
};

const getSubdomain = (url: string): string | null => {
    try {
        const { hostname } = new URL(url);

        return hostname.split('.')[0].toUpperCase();
    } catch {
        return null;
    }
};

export { useConfigureHttpClient };
